import GradientBg from "@/components/common/GradientBg";
import { BRAND } from "@/branding.config";

export default function Privacy() {
  return (
    <div className="relative">
      <GradientBg variant="soft" />
      <section className="relative mx-auto max-w-3xl px-6 pt-28 pb-32">
        <div className="text-xs uppercase tracking-[0.2em] text-primary font-bold">Legal</div>
        <h1 className="mt-3 text-5xl font-black tracking-tight">Privacy Policy</h1>
        <p className="mt-3 text-sm text-muted-foreground">Last updated: {new Date().toLocaleDateString()}</p>
        <div className="mt-10 space-y-6 text-muted-foreground leading-relaxed">
          <p>{BRAND.legal_company_name} ("we", "us") operates the {BRAND.website_url.replace(/^https?:\/\//, "")} platform. This policy explains what
          personal data we collect, how we use it, and your rights under GDPR and comparable regulations.</p>
          <h2 className="text-xl font-bold text-foreground">Data we collect</h2>
          <p>Account data (name, email), billing data (masked card, invoices), operational data
          (VPS metadata, resource usage, access logs).</p>
          <h2 className="text-xl font-bold text-foreground">How we use it</h2>
          <p>To provide the service, invoice you, prevent fraud, and comply with legal obligations.</p>
          <h2 className="text-xl font-bold text-foreground">Retention</h2>
          <p>We retain personal data only as long as necessary for the purposes above or as required by law.</p>
          <h2 className="text-xl font-bold text-foreground">Your rights</h2>
          <p>Access, rectification, erasure, portability, restriction and objection. Contact <a className="text-primary hover:underline" href={`mailto:${BRAND.support_email}`}>{BRAND.support_email}</a>.</p>
        </div>
      </section>
    </div>
  );
}
